export default __webpack_public_path__ + "static/media/Believer's Braid of the Eldritch.33722c20.jpg";